import { Stack, Typography } from "@mui/material";
import {useNavigate} from "react-router";
import { appStyles } from "../AppStyles.ts";
import {SessionIntelProfile} from "../sdo/SessionIntelProfile.ts";

type IntelProfileCardEntry = SessionIntelProfile & { type?: string };

const IntelProfileCard = (props: { entry: IntelProfileCardEntry; networkUID: string; onSelect?: () => void }) => {
    const navigate = useNavigate();

    function getIntelIconSrc(icon?: string): string {
        const key = icon ?? "default";
        return `${import.meta.env.BASE_URL}images/intel/${key}.svg`;
    }

    function handleClick() {
        if (props.onSelect) {
            props.onSelect();
            return;
        }
        const typeKey = props.entry.type ?? "entity";
        navigate(`/networks/${props.networkUID}/intel/${typeKey}/${props.entry.key}`, {
            state: { profile: props.entry },
        });
    }

    return (
        <Stack
            direction="row"
            alignItems="center"            // vertical center
            justifyContent="space-between" // pin left + right edges
            onClick={handleClick}
            sx={{
                ...appStyles.cardGeneralStyle,
                width: "100%",
                p: 1,
                cursor: "pointer",
                gap: 2,                      // use gap instead of Stack spacing
            }}
        >
            {/* Left: Icon pinned left */}
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-start"
                sx={{ flexShrink: 0 }}
            >
                <img
                    src={getIntelIconSrc(props.entry.icon)}
                    width={32}
                    height={32}
                    alt="intel profile"
                />
            </Stack>

            {/* Middle: Text grows, stays left aligned */}
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="flex-start"
                sx={{
                    flexGrow: 1,      // <-- this creates the "middle growth space"
                    minWidth: 0,      // <-- IMPORTANT: allows text truncation/wrapping correctly
                }}
            >
                <Typography sx={appStyles.cardGeneralLabel} noWrap>
                    {props.entry.name}
                </Typography>
                <Typography sx={appStyles.cardGeneralKey} noWrap>
                    {props.entry.key}
                </Typography>
            </Stack>

            {/* Right: Total pinned right + right-aligned */}
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                sx={{
                    flexShrink: 0,
                    minWidth: 64,        // keeps column stable (adjust as needed)
                    textAlign: "right",
                }}
            >
                <Typography sx={appStyles.cardGeneralTotal}>
                    {props.entry.total}
                </Typography>
            </Stack>
        </Stack>
    );

};

export default IntelProfileCard;
